export default "<figure>\n    <div>\n      <img src=\"../../../assets/images/Download-0.6s-200px.svg\">\n    </div>\n  </figure>\n  "